module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dJKui"))).then(() => parcelRequire('1iHdE'));